export const STORE_NAMES = {
  AUTH: 'auth-store',
  ONBOARD: 'onboard-store',
} as const;
